window.autoPfandLoaded = true;

(function () {
  /* Variant-IDs des Pfandprodukts im Shop ninetythree (Produkt 9037432455475) */
  const pfandVariants = {
    '0.25': 48467693175091,
    '0.10': 50324583547187,
    '0.08': 48467693207859
  };

  const RUHE_MS = 250;

  let isSyncing = false;
  let syncTimer = null;
  let pfandCache = {};

  async function getPfandDataForProduct(productHandle) {
    if (Object.prototype.hasOwnProperty.call(pfandCache, productHandle)) {
      return pfandCache[productHandle];
    }

    try {
      const response = await fetch('/products/' + productHandle + '?view=pfand');
      const html = await response.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const pfandScript = doc.getElementById('product-pfand-data');

      if (pfandScript) {
        const pfandData = JSON.parse(pfandScript.textContent);
        pfandCache[productHandle] = pfandData;
        return pfandData;
      }

      pfandCache[productHandle] = null;
      return null;
    } catch (error) {
      console.error('Pfand-System: Fehler beim Laden von ' + productHandle + ':', error);
      /* Nicht cachen - beim naechsten Versuch neu laden */
      return null;
    }
  }

  function getPfandForVariant(pfandData, variantId) {
    if (!pfandData) return { art: '', menge: 0 };

    if (pfandData.variants && pfandData.variants[variantId]) {
      const variant = pfandData.variants[variantId];
      return {
        art: (variant.pfandart || '').trim(),
        menge: parseInt(variant.pfandmenge || 0, 10)
      };
    }

    return {
      art: (pfandData.pfandart || '').trim(),
      menge: parseInt(pfandData.pfandmenge || 0, 10)
    };
  }

  /*
    Warenkorb korrigieren und anschliessend Dawns eigenes cartUpdate-Event
    ausloesen. cart-items und cart-drawer-items lauschen darauf und rendern
    sich per onCartUpdate() selbst neu - mit ihren eigenen Methoden.
    Eigenes innerHTML-Ersetzen zerstoert die Custom Elements und laesst
    registerSwitchButtons() abstuerzen.
  */
  async function updateCart(updates) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        /* source != 'cart-items', damit die Listener wirklich reagieren */
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-pfand' });
      } else {
        document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
          if (typeof el.onCartUpdate === 'function') el.onCartUpdate();
        });
      }
    } catch (e) {
      console.error('Pfand-System: Anzeige konnte nicht aktualisiert werden:', e);
    }

    /* Zaehler im Header nachziehen */
    try {
      const r = await fetch('/?section_id=cart-icon-bubble');
      const t = await r.text();
      const neu = new DOMParser().parseFromString(t, 'text/html').querySelector('.shopify-section');
      const alt = document.getElementById('cart-icon-bubble');
      if (neu && alt) alt.innerHTML = neu.innerHTML;
    } catch (e) {}
  }

  async function syncPfand() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const pfandIds = Object.values(pfandVariants);
      const productItems = cart.items.filter(function (item) {
        return pfandIds.indexOf(item.variant_id) === -1;
      });

      /* Warenkorb enthaelt nur noch Pfand -> Pfand komplett entfernen */
      if (productItems.length === 0) {
        const updates = {};
        let hasPfand = false;

        pfandIds.forEach(function (pfandId) {
          const pfandItem = cart.items.find(function (i) { return i.variant_id === pfandId; });
          if (pfandItem && pfandItem.quantity > 0) {
            updates[pfandId] = 0;
            hasPfand = true;
          }
        });

        if (hasPfand) await updateCart(updates);
        return;
      }

      const totalPfandByType = {};

      for (const item of productItems) {
        const pfandData = await getPfandDataForProduct(item.handle);
        const pfand = getPfandForVariant(pfandData, item.variant_id);

        if (pfand.art && pfand.menge && pfandVariants[pfand.art]) {
          totalPfandByType[pfand.art] =
            (totalPfandByType[pfand.art] || 0) + item.quantity * pfand.menge;
        }
      }

      const updates = {};
      let needsUpdate = false;

      Object.keys(pfandVariants).forEach(function (art) {
        const pfandId = pfandVariants[art];
        const currentItem = cart.items.find(function (i) { return i.variant_id === pfandId; });
        const currentQty = currentItem ? currentItem.quantity : 0;
        const targetQty = totalPfandByType[art] || 0;

        if (currentQty !== targetQty) {
          updates[pfandId] = targetQty;
          needsUpdate = true;
        }
      });

      if (needsUpdate) await updateCart(updates);
    } catch (error) {
      console.error('Pfand-System Fehler:', error);
    } finally {
      isSyncing = false;
    }
  }

  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncPfand();
    }, RUHE_MS);
  }

  /*
    Dawn loest cartUpdate zwar selbst aus, aber erst NACH dem Rendern mit
    noch unkorrigiertem Pfand. Wir haengen uns deshalb zusaetzlich an fetch.
  */
  const nativeFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
    const result = nativeFetch.apply(this, arguments);

    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !isSyncing) {
      result.then(scheduleSync).catch(function () {});
    }

    return result;
  };

  setTimeout(syncPfand, 500);
  document.addEventListener('submit', scheduleSync, true);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleSync();
  });
})();